// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"885e86fc","72":"9c2113a2","477":"ea6dd02b","627":"57de93e4","663":"dc7764a0","667":"f2d04daf","777":"c0eddf96","803":"ffdad544","820":"a516de0c"}[chunkId] + ".chunk.js";
};